import React, { useState, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CustomButton, CustomSelector } from '@components';
import { districtOptionsData } from '@interface';
import { categoryValueSelector } from '@utils';
import { districtOptions, zipCodeOptions } from '@mockData';
import { debounce } from 'lodash';
import { ZipCodeInput } from '@components';
import { useDispatch } from 'react-redux';
import { setDistrictOptionState, } from '@/store/slice';
import { resetDistrictProperty } from '@/store/districtSlice';

interface DistrictSelectorProps {
	module?: string;
	id?: string;
}

export const DistrictSelector: React.FC<DistrictSelectorProps> = ({
	module,
	id,
}) => {
	const dispatch = useDispatch();
	const [selectionCategory, setSelectionCategory] = useState<string>('');
	const [categoryValue, setCategoryValue] = useState<string>('');
	const [categoryList, setCategoryList] = useState<districtOptionsData[]>([]);
	const [zipCodeToggle, setZipCodeToggle] = useState<boolean>(false);
	const [isDashboardRoute, setIsDashboardRoute] = useState<boolean>(false);
	
	useEffect(() => {
		onComponentRender();
	}, [module, id]);

	const onComponentRender = () => {
		if (module && id) {
			setSelectionCategory(module);
			setCategoryValue(id);
			setIsDashboardRoute(true);
			const options = categoryValueSelector(module);
			setCategoryList(options);
			dispatch(setDistrictOptionState({ id, module }));
		}
	};

	const navigate = useNavigate();

	const fetchResults = async (query: string) => {
		if (!query) {
			setCategoryList(zipCodeOptions);
			setZipCodeToggle(true);
			return;
		}
		const mockData = zipCodeOptions.filter((item) =>
			item.value.includes(query.toLowerCase())
		);
		setCategoryList(mockData);
		setZipCodeToggle(true);
	};

	const debouncedFetchResults = useCallback(debounce(fetchResults, 500), []);

	const handleSelectCategoryChange = (value: string) => {
		setCategoryValue('');
		setSelectionCategory(value);
		const options = categoryValueSelector(value);
		setCategoryList(options);
		dispatch(setDistrictOptionState({ id: '', module: value }));
	};

	const handleCategoryValueChange = (value: string) => {
		dispatch(resetDistrictProperty());
		setCategoryValue(value);
		navigate(`/district-dashboard/${selectionCategory}/${value}`);
	};

	const handleZipCodeChange = (value: string) => {
		setCategoryValue(value);
		debouncedFetchResults(value);
	};
	const navigaterFunction = (val: string) => {
		dispatch(resetDistrictProperty());
		setCategoryValue(val);
		setZipCodeToggle(false);
		navigate(`/district-dashboard/${selectionCategory}/${val}`);
	};

	const handleButtonAtionChange = () => {
		setSelectionCategory('');
		if (isDashboardRoute && categoryValue) {
			navigate(`/district-dashboard`);
			dispatch(setDistrictOptionState({ id: '', module: '' }));
		} else {
			onComponentRender();
		}
	};

	return (
		<div className="flex flex-col md:flex-row  md:items-center md:align-middle space-y-3 md:space-y-0 md:space-x-3 w-full">
			<div>
				<CustomSelector
					value={selectionCategory}
					onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
						handleSelectCategoryChange(e.target.value)
					}
					list={districtOptions}
					label={''}
					labelClassName=""
					customDivStyle="flex flex-grow w-auto"
				/>
			</div>

			{selectionCategory && (
				<div>
					{selectionCategory !== 'zipcode' ? (
						<CustomSelector
							value={categoryValue}
							onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
								handleCategoryValueChange(e.target.value)
							}
							list={categoryList}
							label={''}
							labelClassName=""
							customDivStyle="flex flex-grow w-auto"
						/>
					) : (
						<ZipCodeInput
							value={categoryValue}
							onChange={handleZipCodeChange}
							toggleDropdown={zipCodeToggle}
							setToggleDropdown={setZipCodeToggle}
							results={categoryList}
							onSelect={navigaterFunction}
						/>
					)}
				</div>
			)}

			{selectionCategory && (
				<div>
					<CustomButton
						handleOnClick={handleButtonAtionChange}
						btnText={categoryValue ? 'Clear' : 'Cancel'}
						buttonClass="px-8 h-10 bg-[#324B69] text-white font-semibold rounded hover:bg-[#495f7c] w-auto mt-1"
						topViewClass=""
					/>
				</div>
			)}
		</div>
	);
};
